module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    ref: "login",
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "login-wrapper-auot"
  }, [_c('span', {
    staticClass: "logintet"
  }, [_vm._v(_vm._s(_vm.$t('signin')))]), _vm._v(" "), _c('div', {
    staticClass: "logdata"
  }, [_c('div', {
    staticClass: "logdata-str"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('username')) + "：")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.uname),
      expression: "uname",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "logdata-input",
    domProps: {
      "value": (_vm.username),
      "value": (_vm.uname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      },
      "change": function($event) {
        _vm.uname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uname-tip"
  }, [_vm._v(_vm._s(_vm.tip))])]), _vm._v(" "), _c('div', {
    staticClass: "logdata"
  }, [_c('div', {
    staticClass: "logdata-str"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('password')) + "：")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pw),
      expression: "pw"
    }],
    staticClass: "logdata-input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.pw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logdata-newuser"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isNewUser),
      expression: "isNewUser"
    }],
    staticClass: "checkbtn",
    attrs: {
      "id": "newuser",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isNewUser) ? _vm._i(_vm.isNewUser, null) > -1 : (_vm.isNewUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isNewUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isNewUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isNewUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isNewUser = $$c
        }
      }
    }
  }), _vm._v(" "), (_vm.isNewUser == false) ? _c('label', {
    staticClass: "label-newuser",
    attrs: {
      "for": "newuser"
    }
  }, [_vm._v(_vm._s(_vm.$t('newuser')))]) : _vm._e()]), _vm._v(" "), (_vm.isNewUser == false) ? _c('div', {
    staticClass: "logdata-msg",
    on: {
      "click": function($event) {
        _vm.login($event)
      }
    }
  }, [_c('span', {
    staticClass: "pay"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('signin')) + "\n                  ")])]) : _c('div', {
    staticClass: "logdata-msg",
    on: {
      "click": function($event) {
        _vm.newuser($event)
      }
    }
  }, [_c('span', {
    staticClass: "pay"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('newuser')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "logdata-err"
  }, [_c('span', [_vm._v(_vm._s(_vm.tip2))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-close",
    on: {
      "click": _vm.loginHide
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f96140e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 478
// module chunks = 1